<template lang="pug">
  div(class="site-container")
    // Header
    header-view

    // Navigation Bar
    nav-bar

    // Dynamic body content
    router-view

    // Footer
    footer-view
</template>

<script>
import HeaderView from "@/components/Header";
import NavBar from "@/components/NavBar";
import FooterView from "@/components/Footer";

export default {
  components: {
    HeaderView,
    NavBar,
    FooterView
  }
};
</script>
